import { useTheme } from '@mui/material';
import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `XRPL Blockchain Development Services with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: What programming languages are used with the XRPL?',
      description: `A: The XRPL supports JavaScript (xrpl.js), Python (xrpl.py), Go (xrpl-go), Java (xrpl4j), and PHP client libraries. Hooks are written in C or similar languages and compiled to WebAssembly.`,
      gradientOnFocus: theme.mixins.cyanGradient?.background as string,
    },
    {
      title: 'Q: How does the XRPL compare to Ethereum for DeFi?',
      description: `A: The XRPL prioritizes efficiency, scalability, and security for payments and financial transactions, while Ethereum prioritizes flexibility. If you're building high-volume, low-cost financial applications, XRPL is often the better choice.`,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      title: 'Q: Can I build smart contracts on the XRPL?',
      description: `A: Yes, through Hooks - small, efficient pieces of code that execute before or after transactions. They differ from Ethereum-style smart contracts but are often more efficient for financial use cases.`,
      gradientOnFocus: theme.mixins.violetGradient?.background as string,
    },
    {
      title: 'Q: How much does it cost to transact on the XRPL?',
      description: `A: Transaction fees are fractions of a penny - typically around 0.00001 XRP per transaction, which is measured in thousandths of a cent. This makes high-volume applications economically viable.`,
      gradientOnFocus: theme.mixins.grapeGradient?.background as string,
    },
    {
      title: 'Q: How long does it take to develop an XRPL application?',
      description: `A: Timeline varies based on complexity. A simple payment integration might take 4-6 weeks, while a full DeFi platform with custom Hooks could take 3-9 months. We start with an MVP approach to get you to market faster, then iterate based on real user feedback rather than assumptions.`,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
    {
      title: 'Q: Is the XRPL suitable for enterprise and institutional use?',
      description: `A: Absolutely. The XRPL has processed over $1 trillion in transactions with 10+ years of uninterrupted uptime. Major financial institutions like Archax and OpenEden are already tokenizing real-world assets on XRPL. Its native compliance features, fast settlement, and energy efficiency make it ideal for institutional adoption.`,
      gradientOnFocus: theme.mixins.magentaGradient?.background as string,
    },
    {
      title:
        "Q: What's the difference between XRPL Hooks and Ethereum smart contracts?",
      description: `A: Hooks are lightweight, efficient WebAssembly modules that execute before or after transactions on Layer 1. They're deliberately non-Turing-complete, which makes them more secure and predictable for financial use cases. Ethereum smart contracts offer more flexibility but at the cost of higher gas fees, slower execution, and greater complexity. Choose based on your use case; if you're building financial infrastructure, Hooks are often the better choice.`,
      gradientOnFocus: theme.mixins.raspberryGradient?.background as string,
    },
    {
      title: 'Q: Can XRPL applications integrate with existing systems?',
      description: `A: Yes, and that's one of our specialties. We regularly integrate XRPL with legacy banking systems, ERP platforms, payment processors, and traditional databases. The XRPL provides robust APIs (REST and WebSocket) and client libraries in multiple languages, making integration straightforward for experienced developers.`,
      gradientOnFocus: theme.mixins.cyanGradient?.background as string,
    },
    {
      title: 'Q: What happens if regulations change after we launch?',
      description: `A: The XRPL is designed with compliance flexibility in mind. Native features like authorization controls, token freezing, and credential verification can be adjusted without redeploying your entire system. We build regulatory adaptability into the architecture from day one, so you're not locked into outdated compliance approaches when laws evolve.`,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
  ];
};
